// Fixed-position overlay for a Choices.js dropdown so it renders above modal
export interface ChoicesDropdownOverlay {
  show: () => void;
  hide: () => void;
}

export function createChoicesDropdownOverlay(
  getSelectEl: () => HTMLSelectElement | null,
): ChoicesDropdownOverlay {
  function wrapperEl(): HTMLElement | null {
    return (getSelectEl()?.closest('.choices') as HTMLElement | null) ?? null;
  }

  function dropdownEl(): HTMLElement | null {
    return wrapperEl()?.querySelector<HTMLElement>('.choices__list--dropdown') ?? null;
  }

  function reposition(): void {
    const wrapper = wrapperEl();
    const dropdown = dropdownEl();
    if (!wrapper || !dropdown) return;
    const rect = wrapper.getBoundingClientRect();
    dropdown.style.position = 'fixed';
    dropdown.style.top = `${rect.bottom}px`;
    dropdown.style.left = `${rect.left}px`;
    dropdown.style.width = `${rect.width}px`;
    dropdown.style.zIndex = '1060';
  }

  function show(): void {
    reposition();
    document.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
  }

  function hide(): void {
    document.removeEventListener('scroll', reposition, true);
    window.removeEventListener('resize', reposition);
    const dropdown = dropdownEl();
    if (!dropdown) return;
    dropdown.style.position = '';
    dropdown.style.top = '';
    dropdown.style.left = '';
    dropdown.style.width = '';
    dropdown.style.zIndex = '';
  }

  return { show, hide };
}
